import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { getCheckinStatus, checkin } from '@/api/checkin';
import { loadingIcon } from '@/svg';
import { mixins } from '@/mixins';
import OperateList from '@/components/OperateList/OperateList.vue';

export default {
  components: {
    OperateList
  },
  
  name: 'Campaigns',

  mixins: [mixins],

  data() {
    return {
      loading: true,
      loadingIcon,
      checkInItems: [],
      currentCheckDays: 1,
      operateDataList: [
        {
         id: 'checkin',
         name: 'Checkin',
         icon: 'icon-checkin',
         color: '#e4e5e7',
         leaf: false,
        },
        {
         id: 'detail',
         name: 'History',
         icon: 'icon-order',
         color: '#e4e5e7',
         leaf: false,
         redPoint: false
        },
        {
         id: 'shop',
         name: 'Shop',
         icon: 'icon-shop',
         color: '#e4e5e7',
         leaf: false,
         redPoint: false
        },
        {
         id: 'cards',
         name: 'Cards',
         icon: 'icon-cards',
         color: '#e4e5e7',
         leaf: false,
         redPoint: false
        },
      ]
    }
  },

  computed: {
    ...mapGetters([
      'nickname',
      'userId',
      'credits',
      'avatar'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      

      this.loading = true;
      await this.$store.dispatch('updateUserInfo');
      this.loading = false;
    },

    async onClickOperate(item) {
      if (item.id === 'checkin') {
        this.$router.push({
          path: `/checkin`,
        });
      }

      if (item.id === 'detail') {
        this.$router.push({
          path: `/credits_detail`,
        });
      }

      if (item.id === 'shop') {
        this.$router.push({
          path: `/shop`,
        });
      }

      if (item.id === 'cards') {
        this.$router.push({
          path: `/boost_cards`,
        });
      }
    },
  }
}



